import { styled } from '@material-ui/core/styles';

export const Container = styled('div')(({ theme }) => ({
  height: '100vh',
  display: ' flex',
  background: theme.colors.lightGray,
  color: theme.colors.black,
}));
